export type FertilizerProduct = {
    created_by?: number;
    density?: string;
    fertilizer_type?: number;
    id: number;
    last_modified_by: number;
    lbs_N_per_gallon: string;
    name: string;
    percent_N: number;
    special_key: "NH3" | null;
};

export const ApplicationTypes = {
    1: "uniform",
    2: "vrf",
    3: "vri",
};

export const FertilizerTypes = {
    Dry: 1,
    NotDry: 2,
};

export type Fertilizer = {
    id: number;
    name: string;
    percent_N: number;
    lbs_N_per_gallon: number;
    density: number;
    fertilizer_type: FertilizerType;
    created_by: number;
    last_modified_by: number;
};

export enum FertilizerType {
    Dry = 1,
    Liquid = 2,
}
